module.exports = __webpack_public_path__ + "img/tech-services-for-organs.4dc19cf.svg";